import * as Yup from 'yup';

export const VerifyCodeSchema = (t: any) => Yup.object().shape({
  code: Yup.string()
    .required('Код обязателен для заполнения')
    .length(4, 'Код должен состоять из 4 цифр'),
});

